// extracted by mini-css-extract-plugin
export default {"crossButton":"CrossButton_crossButton__JszD8","crossIcon":"CrossButton_crossIcon__hE0oi","placeHolderShimmer":"CrossButton_placeHolderShimmer__iGEOV"};